const FIXED_PRICES = 'pricesFixedForm';
const CATEGORY_PRICES = 'pricesCategoryForm';
const DAILY_PRICES = 'pricesDailyForm';

export { FIXED_PRICES, CATEGORY_PRICES, DAILY_PRICES };
